import {Component, Inject, SecurityContext} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  public data;
  public dismissDialogText = 'OK';
  constructor(@Inject(MAT_DIALOG_DATA) private messageInfo: any, private sanitizer: DomSanitizer) { }

  ngOnInit(){
    if (this.messageInfo) {
      if (typeof this.messageInfo === "string") {
        this.data = this.messageInfo;
      }
      else {
        // messageInfo is an object
        if (this.messageInfo.dismissDialogText) {
          // Set the dismiss button text if specified
          this.dismissDialogText = this.messageInfo.dismissDialogText;
        }
        if (this.messageInfo.messageType && this.messageInfo.messageType === 'file') {
          this.readFileToString(this.messageInfo.message)
        }
        else {
          this.data = this.messageInfo.message;
        }
      }
    }
  }

  /**
   * If dialog info is in a file, reads the file content to a string
   * @param fileNm 
   */
  private async readFileToString(fileNm) {
    await fetch (fileNm).then(
       res => res.text()).then(
         tempData => {
       this.data = this.sanitizer.sanitize(SecurityContext.HTML,this.sanitizer.bypassSecurityTrustHtml(tempData));
     });  
 
   }

}
